<template>
  <v-layout>
    <v-col class="shrink">
      <v-img max-width="150" :src="pdfInfo.thumbnailUrl"></v-img>
    </v-col>
    <v-layout column class="site-info">
      <v-col class="font-weight-bold px-0 pt-2 pb-0">{{ resource.text || pdfInfo.name }}</v-col>
      <div class="caption px-0 pt-1 pb-0 truncate">
        <a @click.stop :href="pdfInfo.downloadUrl" target="_blank">Download PDF</a>
      </div>
      <v-col class="caption px-0 pt-1 pb-0">
        {{ pdfInfo.size }} |
        <v-icon x-small>label</v-icon>
        <template v-for="tag in tags">
          {{ tag.text }}
        </template>
      </v-col>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    pdfInfo: { default: () => ({}) }
  },
  data() {
    return {
    };
  },
  computed: {
    tags() {
      return this.resource.tags.userDefined;
    }
  },
  methods: {}
};
</script>

<style>
.site-info div {
  line-height: 1.3 !important;
}
</style>
